module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAPFBMVEUAAAAHwWAHwmEAqlUHwl8HwV8HwWAHwF8GvF4HwV8AxGIIv2AHwGAMwmEHwGAHv2MHwWAJwWEHwmEHwF8wD8W0AAAAFHRSTlMA/9MGu071qy6LDUDgFcwk6h3Dsyt+qf4AAAA9SURBVHicY8AKONmZkbmMjMJcSFxWNkYWXiQ+twCjkCASn4OHkY8fSDMxwgETJhdNMTaj0CxCcwaaI2EAAKYUAZ2cndrcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/right.png
// module id = K/nF
// module chunks = 0